import { useAuthContext } from '@/auth/AuthProvider'
import { NO_ROLES, type Roles } from './roles'

/** The signed-in identity's roles, or none while signing in or signed out. */
export function useRoles(): Roles {
  const { authState } = useAuthContext()
  return authState.status === 'authenticated' ? authState.roles : NO_ROLES
}
